<template>
  <div class="app-container">
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.search.provinceId"
              filterable
              clearable
              placeholder="请选择省区"
              style="width:100%"
              @change="changeProvinceFun"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.search.cityId"
              filterable
              clearable
              placeholder="请选择城市"
              style="width:100%"
              @change="changeCityFun"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.search.countyId"
              filterable
              clearable
              placeholder="请选择区县"
              style="width:100%"
            >
              <el-option
                v-for="item in countyOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.search.status"
              filterable
              clearable
              placeholder="请选择状态"
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.label"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col style="width:70px;padding-left:10px;">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
          <!-- <el-col
            style="width:110px;padding-left:10px;"
          >
            <el-button
              type="success"
              @click="showSearchLocationFun()"
            >
              当前签到定位
            </el-button>
          </el-col> -->
        </el-row>
      </div>
      <!-- 地图信息 -->
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div
          id="container"
          ref="container"
          :style="{width:EchartsWidth,height: EchartsHeight }"
          class="map-container"
        />
      </div>
    </div>
    <!-- 查看 -->
    <check-in-location-dialog
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />
  </div>
</template>

<script>
// 查看当前签到定位
import checkInLocationDialog from './components/checkInLocationDialog'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { getStoreListApi,getLocationByAddressApi } from '@/api/store'
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  name: 'StoreLocationMap',
  components: {
    checkInLocationDialog
  },
  mixins: [],
   data () {
    return {
      // 主列表
      masterList: {
        // 查询条件
        search: {
          provinceId: null,
          cityId: null,
          countyId: null,
          status: null,
          billType: 1
        }
      },
      provinceOptions: [],
      cityOptions: [],
      countyOptions: [],
      statusOptions: [{label:'维护中',data:1},{label:'停止维护',data:2}],
      storeList: [],
      dialogViewTitle: '当前签到定位',
      dialogViewVisible: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      EchartsHeight: (document.body.clientHeight - 135 )+'px',
      EchartsWidth:(document.body.clientWidth - 240)+'px',
      map: null, // 地图底层
      markers: null, //标记数组
      markerCluster: null, //标记集
      infoWindow: null  //消息窗口
    }
  },
   created () {
    this.storeList = []
    this.$nextTick(() => {
      this.initProvinceSelectData()
    })
  },
  methods: {
    // 加载数据
    searchData () {
      if(this.masterList.search.provinceId === null || this.masterList.search.provinceId === undefined || this.masterList.search.provinceId === ''){
        this.$message({
          message: '请选择省区',
          type: 'warning'
        })
        return false
      }
      if(this.masterList.search.cityId === null || this.masterList.search.cityId === undefined || this.masterList.search.cityId === ''){
        this.$message({
          message: '请选择城市',
          type: 'warning'
        })
        return false
      }
      this.loading - true
      getStoreListApi(this.masterList.search).then(res => {
        this.storeList = res.data
        if(this.storeList !== null && this.storeList !== undefined && this.storeList.length > 0){
          let address = this.storeList[0].provinceName+this.storeList[0].cityName
          getLocationByAddressApi({address: address}).then(res1 => {
            let locationMap = res1.data
            locationMap.dataArr = this.storeList
            //this.qqMap(locationMap)
            this.initAMap(locationMap)
            this.loading = false
          })
        } else {
          this.$message({
            message: '未查询到终端数据',
            type: 'warning'
          })
          this.markerCluster.clearMarkers()
        }
      })
    },
    //高德地图
    initAMap(locationMap) {
      let _this = this
      if(locationMap.lat && Number(locationMap.lat) === 0){
        locationMap.lat = 30.657000
        locationMap.lng = 104.066002
      }
      window._AMapSecurityConfig = {
        securityJsCode: "633bc5cb2162fdb3c4a8e5d2d5aa0daa",
      };
      AMapLoader.load({
        key: "f21da6bcb395bf6636a0cfdfce27bb8f", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale","AMap.MarkerCluster"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          if(_this.map === null){
          _this.map = new AMap.Map("container", {
            // 设置地图容器id
            viewMode: "2D", // 是否为3D地图模式
            zoom: 11, // 初始化地图级别
            center: [locationMap.lng, locationMap.lat], // 初始化地图中心点位置
          });
          } else {
            _this.map.setZoom(11)
            _this.map.setCenter([locationMap.lng, locationMap.lat])
          }
          let points = []
          locationMap.dataArr.forEach(item => {
            if(item.lat !== null && item.lat !== undefined){
              points.push({lnglat: [item.lng,item.lat], title: item.storeName})
            }
          })
          if(_this.markerCluster === null){
            _this.markerCluster = new AMap.MarkerCluster(_this.map, points);
            _this.markerCluster.on("click",function(event){
              let info = ''
              if(event.clusterData.length === 1){
                info = event.clusterData[0].title
              }
              if(_this.infoWindow === null){
                _this.infoWindow = new AMap.InfoWindow({
                    offset: [0,-30],
                    content: info  //使用默认信息窗体框样式，显示信息内容
                });
              } else {
                _this.infoWindow.setContent(info)
              }
              if(info.length > 0){
                _this.infoWindow.open(_this.map, event.clusterData[0].lnglat);
              }
            })
          } else {
            _this.markerCluster.setData(points)
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 腾讯地图
    qqMap(data){
      let center = new qq.maps.LatLng(data.lat, data.lng)
      if(this.map === null){
        this.map = new qq.maps.Map(this.$refs.container, {
            center: center,
            zoom: 11
        })
      } else {
        this.map.setCenter(center)
      }
      if(this.markers === null){
        this.markers = new qq.maps.MVCArray()
      } else {
        this.markers = []
      }
      for (let i = 0; i < data.dataArr.length; i++) {
        let markerData = data.dataArr[i]
        if(markerData.lat === null || markerData.lat === undefined) continue
        let markerLatLng = new qq.maps.LatLng(markerData.lat, markerData.lng)
        let marker = new qq.maps.Marker({
          //设置Marker的位置坐标
          position: markerLatLng,
          //设置显示Marker的地图
          map: this.map
        })
        if(markerData.realStoreName !== null && markerData.realStoreName !== undefined && markerData.realStoreName.length > 0){
          marker.setTitle(markerData.storeName + "(" + markerData.realStoreName + ")")
        } else {
          marker.setTitle(markerData.storeName)
        }
        this.markers.push(marker)
      }
      if(this.markerCluster === null){
        this.markerCluster = new qq.maps.MarkerCluster({
            map:this.map,
            minimumClusterSize:5, //默认2
            markers:this.markers,
            zoomOnClick:true, //默认为true
            gridSize:30, //默认60
            averageCenter:true, //默认false
            maxZoom:18, //默认18
        })
      } else {
        this.markerCluster.clearMarkers()
        this.markerCluster.addMarkers(this.markers)
      }
    },
    // 初始省区下拉数据
    initProvinceSelectData(){
      loadAreaDataApi({ parentId: 1, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun(val){
      this.cityOptions = []
      this.countyOptions = []
      this.masterList.search.cityId = null
      this.masterList.search.countyId = null
      this.initCitySelectData(val)
    },
    // 初始城市下拉数据
    initCitySelectData(val){
      loadAreaDataApi({ parentId: val, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun (val){
      this.countyOptions = []
      this.masterList.search.countyId = null
      this.initCountySelectData(val)
    },
    // 初始区县下拉数据
    initCountySelectData(val){
      loadAreaDataApi({ parentId: val, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.countyOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 当天签到定位
    showSearchLocationFun(){
      this.dialogViewVisible = !this.dialogViewVisible
    }
  }
}
</script>
<style lang="scss" scoped>
.map-container {
  padding-top: 5px;
}
</style>
